import React from "react";
import { Outlet } from "react-router-dom";
import "./ProfileLayout.css";

const ProfileLayout = () => {
  return (
    <div className="ProfileLayout">
      <Outlet />
    </div>
  );
};

export default ProfileLayout;
